/**
 * Назначения посева рядом с культурой — компактные бейджи
 * («Тритикале озимая · зелёный корм»).
 *
 * Назначений нет → компонент не рендерит ничего (пустое состояние не шумит).
 * Чипы переносятся по строкам (flex-wrap) и режут длинные имена, чтобы не
 * разъезжать таблицу истории и карточку посева на узких экранах.
 */
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { GrowingGoalRef } from './types';

interface Props {
  goals?: GrowingGoalRef[] | null;
  className?: string;
}

export function GrowingGoalChips({ goals, className }: Props) {
  if (!goals || goals.length === 0) return null;
  return (
    <div className={cn('flex flex-wrap items-center gap-1', className)}>
      {goals.map((g) => (
        <Badge
          key={g.id}
          variant="outline"
          className="max-w-[12rem] truncate border-border font-normal text-muted-foreground"
          title={g.name_ru}
        >
          {g.name_ru}
        </Badge>
      ))}
    </div>
  );
}
